import React from 'react';

function UnsubscribeImage({ size }) {
  return (
    <div className={`unsubscribe-${size}-image`} />
  );
}

export default UnsubscribeImage;
